'use strict';

angular.module('amexReconciliationApp')
  .component('exportDropdownButton', {
    templateUrl: 'scripts/views/components/export-dropdown-button.html',
    controller: function ($rootScope,
                          $element,
                          SelectedTransactionService,
                          TransactionSortModel,
                          $uibModal) {
      var self = this;

      self.allTransactionIds = function () {
        var allTransactionIds = _.map(TransactionSortModel.transactions(), 'id');

        return _.join(allTransactionIds, ',');
      };

      self.selectedTransactionIds = function() {
        var selectedTransactionIds = _.map(SelectedTransactionService.selectedTransactions(), 'id');

        return _.join(selectedTransactionIds, ',');
      };

      self.openExportAllModal = function() {
        openExportModal(self.allTransactionIds());
      };

      self.openExportSelectedModal = function() {
        openExportModal(self.selectedTransactionIds());
      };

      self.selectedTransactionsCount = SelectedTransactionService.selectedTransactionsCount;

      self.isDisabled = function() {
        return _.isEmpty(TransactionSortModel.transactions());
      };

      self.noSelectedTransactions = function() {
        return self.selectedTransactionsCount() === 0;
      };

      function openExportModal(transactionIds) {
        var scopeWithTransactionIds = $rootScope.$new();
        scopeWithTransactionIds.transactionIds = transactionIds;
        $uibModal.open({
          template: '<export-modal transaction-ids="transactionIds" close-modal-callback="$close()"></export-modal>',
          size: 'md',
          scope: scopeWithTransactionIds
        });

      }
    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/exportDropdownButton.js
// module id = 448
// module chunks = 0